import { Identity, Permissions, UserState } from "@/shared/domain";

export const shouldAllowConversations = (user: Identity, userState: UserState): boolean => {
    return (
        user.isAuthenticated &&
        userState !== UserState.UNKNOWN &&
        userState !== UserState.PENDING &&
        user.hasGlobalPermission(Permissions.AccessConversations)
    );
};
